import React from "react";

import { MasterPage } from "./components/MasterPage/MasterPage";

export class App extends React.Component {
  render() {
    return <MasterPage />;
  }
}
